<div class="flex">
  <section class="flex-1 flex flex-col max-h-screen h-screen overflow-hidden">
    <ng-container *ngIf="property">
      <div class="prop-cal-header flex flex-col gap-3">
        <div class="flex items-center justify-between gap-3">
          <app-feature-flag-tabs>
            <sbnb-page-header
              navTabs
              *ngIf="source != null"
              [parentPath]="source | fn: getParentPath : null : property.id"
              class="mt-5 pl-4 mb-0"></sbnb-page-header>
          </app-feature-flag-tabs>
          <div class="flex flex-1 gap-2 items-center">
            <sbnb-property-select-dropdown
              class="w-full md:max-w-[500px]"
              *ngIf="properties?.length > 0"
              [properties]="properties"
              [showPlaceholder]="false"
              [selectedPropertyId]="property.id"
              (selectedPropertyChanged)="propertyChanged($event)"></sbnb-property-select-dropdown>
            <sbnb-alert-card
              *ngIf="property.calendar_restricted"
              context="info"
              class="items-center gap-2 !hidden md:!flex">
              <sbnb-icon icon="alert-circle"></sbnb-icon>
              <span>
                To manage pricing and availability from Hospitable's calendar,
                <a class="link-muted !text-night" [routerLink]="['/accounts']">upgrade your channel connection.</a>
              </span>
            </sbnb-alert-card>
          </div>

          <div class="flex items-center gap-2">
            <sbnb-button
              *ngIf="
                (previewToMobileModalCTA$ | async) &&
                !$dynamicPricingOn() &&
                (dynamicPricingVisible$ | async) !== true
              "
              size="mini"
              type="secondary-grape"
              icon="eye"
              iconClasses="!text-grape"
              (click)="presentMobileDPModal()"
              label="Preview dynamic pricing"></sbnb-button>

            <sbnb-button
              *ngIf="
                (pricingSettingsSidebarAvailable$ | async) &&
                !$dynamicPricingOn() &&
                (dynamicPricingVisible$ | async) !== true
              "
              size="mini"
              type="secondary-grape"
              icon="eye"
              iconClasses="!text-grape"
              (click)="previewDynamicPricing()"
              label="Preview dynamic pricing"></sbnb-button>

            <sbnb-icon-dynamic-pricing
              *ngIf="$dynamicPricingOn()"
              matTooltip="Dynamic pricing is enabled"></sbnb-icon-dynamic-pricing>

            <mat-button-toggle-group
              *ngIf="
                (perms$.hasAccessTo(Features.PERM_CALENDAR) | async) &&
                (perms$.hasAccessTo(Features.PERM_TASKS) | async)
              "
              class="text-xs font-bold"
              [(ngModel)]="mode"
              (ngModelChange)="clearSelected()">
              <mat-button-toggle value="occupancy">
                <div class="flex gap-2 align-center leading-normal p-[11px]">
                  <sbnb-icon [size]="16" icon="adults"></sbnb-icon>
                  <span class="hidden xl:block" [ngClass]="{ 'md:block': !property.calendar_restricted }">
                    Occupancy
                  </span>
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="tasks">
                <div class="flex gap-2 align-center leading-normal p-[11px]">
                  <sbnb-icon [size]="16" icon="task"></sbnb-icon>
                  <span class="hidden xl:block" [ngClass]="{ 'md:block': !property.calendar_restricted }">Tasks</span>
                </div>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
      <div #calendarContent class="flex h-full overflow-auto max-h-full justify-between">
        <div class="prop-cal-body">
          <ng-container *ngIf="dynamicPriceMap$ | async as dynamicPriceMap">
            <article *ngFor="let month of months" class="month-container">
              <div
                class="month-heading"
                [class.this-month]="
                  startMonth
                    ? (month[month.length - 1] | date: 'MM') == startMonth
                    : (month[month.length - 1] | isThisMonth)
                "
                fxLayoutAlign="start center"
                fxLayoutGap="12px">
                <span>
                  {{ month[month.length - 1] | date: 'MMM y' }}
                </span>
                <mat-spinner *ngIf="loadingPricing" class="loading-spinner" [diameter]="12"></mat-spinner>
              </div>

              <div class="days-of-week">
                <div *ngFor="let dow of daysOfWeek">{{ dow }}</div>
              </div>

              <div class="month">
                <div
                  class="week"
                  *ngFor="let unused of [].constructor(math.ceil(month.length / 7)); let weekNum = index">
                  <div
                    *ngFor="let unused of [].constructor(7); let dayNum = index"
                    [satPopoverAnchor]="p"
                    [satPopoverHover]="400"
                    class="day"
                    [class.no-day]="!month[weekNum * 7 + dayNum]"
                    [class.is-unavailable]="
                      month[weekNum * 7 + dayNum] && !pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.available
                    "
                    [class.is-manual-block]="month[weekNum * 7 + dayNum] | isManualBlock: pricingAndAvailability"
                    [class.is-manual-block-tail]="
                      dayNum === 0 && month[weekNum * 7 + dayNum - 1] | isManualBlock: pricingAndAvailability
                    "
                    [class.cannot-interact]="
                      !pricingAndAvailability?.[month[weekNum * 7 + dayNum]] ||
                      (month[weekNum * 7 + dayNum] && (month[weekNum * 7 + dayNum] | isBeforeToday))
                    "
                    [class.selected]="
                      selectedDates?.length > 0 && selectedDates?.indexOf(month[weekNum * 7 + dayNum]) > -1
                    "
                    [class.hovered]="
                      hoveredDates?.length > 0 && hoveredDates?.indexOf(month[weekNum * 7 + dayNum]) > -1
                    "
                    (click)="
                      month[weekNum * 7 + dayNum]
                        ? dateClicked(month[weekNum * 7 + dayNum], property, tasks[month[weekNum * 7 + dayNum]])
                        : null
                    "
                    (mouseover)="
                      month[weekNum * 7 + dayNum] && mode === 'occupancy'
                        ? dateHovered(month[weekNum * 7 + dayNum])
                        : null
                    ">
                    <!-- dynamic price breakdown popup -->
                    <sat-popover verticalAlign="below" horizontalAlign="start" #p>
                      <sbnb-dynamic-price-daily-breakdown
                        *ngIf="
                          (pricingSettingsSidebarAvailable$ | async) &&
                          (dynamicPricingVisible$ | async) &&
                          dynamicPriceMap[month[weekNum * 7 + dayNum]]?.price?.attribution
                        "
                        [preview]="dynamicPriceMap[month[weekNum * 7 + dayNum]]?.price"
                        [currentPrice]="
                          pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.price
                        "></sbnb-dynamic-price-daily-breakdown>
                    </sat-popover>
                    <span class="day-date">{{ month[weekNum * 7 + dayNum] | date: 'd' }}</span>

                    <!-- occupancy only-->
                    <ng-container *ngIf="mode === 'occupancy'">
                      <div
                        class="manual-block"
                        *ngIf="month[weekNum * 7 + dayNum] | isManualBlock: pricingAndAvailability"></div>
                      <div
                        class="manual-block-tail"
                        *ngIf="
                          dayNum === 0 && month[weekNum * 7 + dayNum - 1] | isManualBlock: pricingAndAvailability
                        "></div>
                      <div
                        class="closed-for-ci"
                        *ngIf="
                          pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.closed_for_checkin &&
                          pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.available
                        "></div>
                      <div
                        class="closed-for-co"
                        *ngIf="
                          pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.closed_for_checkout &&
                          pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.available
                        "></div>
                      <div class="flex flex-col-reverse gap-2 items-end justify-start p-1 absolute bottom-0 right-0">
                        <!-- Dynamic pricing suggestion -->
                        <span
                          class="day-dynamic-pricing-suggestion text-base"
                          *ngIf="
                            (dynamicPricingVisible$ | async) &&
                            pricingAndAvailability &&
                            pricingAndAvailability[month[weekNum * 7 + dayNum]]?.available
                          "
                          [ngClass]="
                            pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.price?.amount
                              | fn
                                : getPriceComparisonColor
                                : null
                                : dynamicPriceMap[month[weekNum * 7 + dayNum]]?.price?.amount
                          ">
                          <ng-container *ngIf="dynamicPricingSuggestionLoading; else dynamicPricingSuggestion">
                            <div class="day-dynamic-pricing-suggestion loading"></div>
                          </ng-container>
                          <ng-template #dynamicPricingSuggestion>
                            {{ dynamicPriceMap[month[weekNum * 7 + dayNum]]?.price?.display?.slice(0, -3) }}
                          </ng-template>
                        </span>
                        <!-- Day price -->
                        <!-- This loader is only shown when dynamic pricing is enabled or updated -->
                        <div
                          *ngIf="loadingPricing && pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.available"
                          class="day-dynamic-pricing-suggestion loading"></div>
                        <span
                          class="day-price ellipsis"
                          [ngClass]="{
                            'dynamic-pricing-source':
                              $dynamicPricingOn() &&
                              (pricingAndAvailability[month[weekNum * 7 + dayNum]].sources | isPriceManualSource)
                          }"
                          *ngIf="
                            !loadingPricing &&
                            pricingAndAvailability &&
                            pricingAndAvailability[month[weekNum * 7 + dayNum]]?.available
                          ">
                          {{
                            pricingAndAvailability &&
                              Math.round(pricingAndAvailability[month[weekNum * 7 + dayNum]]?.price?.amount)
                              | currency
                                : pricingAndAvailability[month[weekNum * 7 + dayNum]]?.price?.currency
                                : 'symbol'
                                : '1.0-0'
                          }}
                        </span>

                        <!-- Min stay indicator -->
                        <span
                          *ngIf="
                            pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.min_stay > 1 &&
                            pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.available
                          "
                          class="min-stay-indicator"
                          [matTooltip]="
                            'Minimum length of stay: ' + pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.min_stay
                          ">
                          <mat-icon>nightlight_outline</mat-icon>
                          {{ pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.min_stay }}
                        </span>

                        <!-- Note indicator -->
                        <span
                          *ngIf="pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.note"
                          class="indicator note-indicator"
                          [matTooltip]="pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.note"></span>

                        <!-- Failure indicator -->
                        <span
                          *ngIf="
                            isCS &&
                            (debugMode$ | async) &&
                            pricingAndAvailability?.[month[weekNum * 7 + dayNum]]?.failures
                          "
                          class="indicator failure-indicator"></span>
                      </div>
                    </ng-container>

                    <!-- tasks only -->
                    <ng-container *ngIf="mode === 'tasks' && tasks[month[weekNum * 7 + dayNum]]">
                      <div
                        *ngFor="let task of tasks[month[weekNum * 7 + dayNum]]"
                        class="task"
                        [class.checkInOutRole]="task.task_type === 4 || task.task_type === 2"
                        [class.cleaningRole]="task.task_type === 1"
                        [class.maintenanceRole]="task.task_type === 5"
                        [class.task__unassigned]="!task.teammate"
                        [class.unassigned__checkInOutRole]="
                          (task.task_type === 4 || task.task_type === 2) && !task.teammate
                        "
                        [class.unassigned__cleaningRole]="task.task_type === 1 && !task.teammate"
                        [class.unassigned__maintenanceRole]="task.task_type === 5 && !task.teammate"
                        [class.multiple_tasks]="(task | hasOverlapWithOtherTasks: property.tasks) > 1">
                        <span *ngIf="(task | hasOverlapWithOtherTasks: property.tasks) === 1">
                          {{ task.teammate ? task.teammate.initials : '?' }}
                        </span>
                        <span *ngIf="(task | hasOverlapWithOtherTasks: property.tasks) > 1">
                          {{ task | hasOverlapWithOtherTasks: property.tasks }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="reservations[month[weekNum * 7 + dayNum]]">
                      <div
                        *ngFor="let reservation of reservations[month[weekNum * 7 + dayNum]]"
                        #reservation
                        class="flex align-center reservation event-platform-{{ reservation.platform }}"
                        [class.apply-event-colors]="true"
                        [class.incorrect-mode]="mode !== 'occupancy' || (dynamicPricingVisible$ | async)"
                        [class.too-short-for-label]="
                          reservation.display_start === reservation.display_end &&
                          reservation.display_start !== (reservation.checkin | date: 'yyyy-MM-dd')
                        "
                        [class.reservation-pending]="
                          reservation.status === 'Pending' || reservation.status === 'Awaiting Payment'
                        "
                        [class.reservation-hovered]="reservation.uuid === hoveredReservationId"
                        [class.old-reservation]="reservation.checkout | isBeforeToday"
                        [class.parent-child-reservation]="reservation.isParentChildReservation"
                        (mouseover)="hoveredReservationId = reservation.uuid"
                        (mouseout)="hoveredReservationId = null"
                        (click)="$event.stopPropagation(); reservationClicked(reservation)"
                        [attr.data-start]="reservation.display_start"
                        [attr.data-end]="reservation.display_end"
                        [attr.data-truestart]="reservation.checkin"
                        [attr.data-trueend]="reservation.checkout"
                        [class.not-true-start]="
                          reservation.display_start !== (reservation.checkin | date: 'yyyy-MM-dd')
                        "
                        [class.not-true-end]="reservation.display_end !== (reservation.checkout | date: 'yyyy-MM-dd')"
                        [style.width.px]="reservation.display_start | propertyCalEventWidth: reservation : width < 640"
                        [class.overlap-detected]="
                          !reservation.isParentChildReservation && conflictingEventsMap[reservation.uuid]?.length
                        "
                        [class.overlap-selected]="reservation.uuid === selectedReservation?.uuid">
                        <span class="ellipsis flex-1">
                          {{ reservation?.guest }}
                        </span>
                        <!-- Nudge the logo a bit to the left if the reservation block is ending on the last day of the week to keep it from being cut off -->
                        <img
                          class="w-4 h-4 md:w-5 md:h-5"
                          [ngClass]="{ 'mr-4': +(reservation.display_end | date: 'c') === startOfWeekPref }"
                          [src]="'/assets/iconography/' + reservation?.channel + '-white.svg'"
                          onerror="this.src='/assets/iconography/manual-white.svg'" />
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </article>
          </ng-container>

          <div *ngIf="loadingMoreMonths" class="property-loader" fxLayout fxLayoutAlign="center center">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </div>
        <div
          class="prop-cal-sidebar"
          [class.mobile-expanded]="
            selectedDates?.length > 1 || selectedReservation || (selectedDates && mode === 'tasks')
          "
          (mouseover)="hoveredDates = null">
          <div
            *ngIf="(pricingSettingsSidebarAvailable$ | async) !== true && !selectedReservation && !selectedDates"
            class="night-lighter sidebar-helper px-3 text-center">
            Select date(s), bookings or tasks to view further options
          </div>

          <sbnb-sidebar-property-settings
            *ngIf="pricingSettingsSidebarAvailable$ | async"
            [ngClass]="{
              hidden: selectedDates?.length > 0 || selectedReservation || (selectedDates && mode === 'tasks')
            }"
            [property]="property"
            (refreshCalendar)="loadingPricing = true; fetchPricingAndAvailability()"></sbnb-sidebar-property-settings>

          <sbnb-sidebar-pricing
            *ngIf="selectedDates?.length > 0 && mode === 'occupancy'"
            [property]="property"
            [loading]="saving"
            [dates]="selectedDates"
            [readonly]="property.calendar_restricted"
            readonlyTooltip="This calendar is limited"
            (close)="clearSelected()"
            (manualBookingSaved)="this.reservations = []; this.getReservations()"
            (save)="savePriceAndAvailability($event)"
            [dynamicPricingUpsellInformation]="
              selectedDates
                | fn
                  : getDPUpsellDate
                  : this
                  : (dynamicPriceMap$ | async)
                  : pricingAndAvailability
                  : (perms$.hasAccessTo(Features.PERM_CALENDAR_UPDATE_PRICING_AND_AVAIL) | async)
                  : $dynamicPricingOptions()?.outbound_dynamic_pricing_enabled
                | async
            "
            (resetToDynamicPricing)="resetToDynamicPricing()"
            (previewDynamicPricing)="previewDynamicPricing('recommended', true)"></sbnb-sidebar-pricing>

          <div *ngIf="selectedReservation" class="sidebar-reservations">
            <sbnb-sidebar-reservation
              *ngIf="selectedReservation"
              [selectedReservation]="selectedReservation"
              [clickedProperty]="property"
              [showJumpToBooking]="false"
              (close)="clearSelected()"
              (reservationNeedsUpdating)="
                fetchUpdatedReservationDetails(selectedReservation)
              "></sbnb-sidebar-reservation>
          </div>

          <div *ngIf="selectedDates?.length > 0 && mode === 'tasks'" style="padding-top: 8px">
            <sbnb-sidebar-tasks
              #sidebarTasks
              [tasks]="daysTasks"
              [date]="{ date: selectedDates[0], hour: '10' }"
              [property]="property"
              (taskCreated)="taskAdded($event)"
              (taskUpdated)="taskUpdated($event)"
              (taskDeleted)="taskDeleted($event)"
              (close)="clearSelected()"></sbnb-sidebar-tasks>
          </div>
        </div>
      </div>
    </ng-container>
  </section>
</div>
